module.exports = __webpack_public_path__ + "img/plan_1.af32fe0b.png";